const PopularScienceList = () => import('Views/article/popular-science-list');
const PopularScienceDetail = () => import('Views/article/popular-science-detail-new-ui');

export default[
  { path: '/popular-science-list', component: PopularScienceList },
  { path: '/popular-science-detail/:id', component: PopularScienceDetail },
];



// WEBPACK FOOTER //
// ./src/router/article.js